import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAthleteSports } from '@api/lookups';
import { IAthleteSport } from '@interfaces/lookups';

export const handleGetAthleteSports = createAsyncThunk<AxiosResponse<IAthleteSport[]>, void>(
  'getAthleteSports',
  getAthleteSports,
);
